import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { trackReports } from '../../../../core/constants/constants';
import { TrackMXVareQVarianceResponse } from '../../../../core/interface/mx-reports';
import { VarianceReportData } from '../../../../core/interface/export-reports';

@Component({
  standalone: false,
  selector: 'app-track-mx-vareq-variance',
  templateUrl: './track-mx-vareq-variance.component.html',
  styleUrl: './track-mx-vareq-variance.component.less',
})
export class TrackMxVareqVarianceComponent implements OnChanges {
  trackReport = trackReports;
  @Input()
  trackMXVareQVarianceResponse!: TrackMXVareQVarianceResponse[];
  @Input()
  reportData!: VarianceReportData;
  totalTrackSum: number = 0;
  totalMaxSum: number = 0;
  totalVarSum: number = 0;
  companyName: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trackMXVareQVarianceResponse'].currentValue != null) {
      this.calculateSum();
      this.companyName = this.trackMXVareQVarianceResponse[0].companyName;
    }
  }

  calculateSum() {
    this.totalTrackSum = 0;
    this.totalMaxSum = 0;
    this.totalVarSum = 0;
    this.trackMXVareQVarianceResponse.forEach((response) => {
      this.totalTrackSum += response.sumTrackHrs;
      this.totalMaxSum += response.sumMaxHrs;
      this.totalVarSum += response.sumVarHrs;
    });
  }
}
